module.exports = __webpack_public_path__ + "static/unlock-global-expertise-43805d722ed8772000b0fc3aae009ba7.png";